import { useEffect } from "react";

const SITE = (process.env.REACT_APP_PUBLIC_SITE_URL || "").replace(/\/$/, "");
const OG_IMAGE = SITE ? `${SITE}/og-share-card.jpg` : "";

const setMeta = (attr, key, content) => {
  if (!content) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

export const Seo = ({ title, description, jsonLd }) => {
  useEffect(() => {
    document.title = title;
    setMeta("name", "description", description);
    setMeta("property", "og:type", "website");
    setMeta("property", "og:site_name", "OFFCRAFT");
    setMeta("property", "og:title", title);
    setMeta("property", "og:description", description);
    setMeta("property", "og:locale", "en_US");
    setMeta("name", "twitter:card", OG_IMAGE ? "summary_large_image" : "summary");
    setMeta("name", "twitter:title", title);
    setMeta("name", "twitter:description", description);
    if (OG_IMAGE) {
      setMeta("property", "og:image", OG_IMAGE);
      setMeta("name", "twitter:image", OG_IMAGE);
    }

    const id = "route-jsonld";
    let el = document.getElementById(id);
    if (jsonLd) {
      if (!el) {
        el = document.createElement("script");
        el.type = "application/ld+json";
        el.id = id;
        document.head.appendChild(el);
      }
      el.textContent = JSON.stringify(jsonLd);
    } else if (el) {
      el.remove();
    }
  }, [title, description, jsonLd]);

  return null;
};
